import { render, staticRenderFns } from "./PagePlace.vue?vue&type=template&id=76533d3e&scoped=true"
import script from "./PagePlace.vue?vue&type=script&lang=js"
export * from "./PagePlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76533d3e",
  null
  
)

export default component.exports